import type { EventHandler, FC, FocusEvent } from "react";

import { DateOnlyPicker, DateTimePicker } from "widgets";

import type { IAdvancedSearchFieldProps } from "./AdvancedSearchCriteria.js";
import { SEARCH_OPERATORS } from "@/app-utils/rsql.ts";

interface DateInputProps {
  value: string;
  changeHandler: (date: string) => void;
  autoFocus?: boolean;
  onBlur: EventHandler<FocusEvent<any>>;
  withTime: boolean;
}

const DateInput: FC<DateInputProps> = (props) => {
  return (
    <div style={{ flex: 1, position: "relative" }}>
      {props.withTime ? (
        <DateTimePicker ISOFormattedDate={props.value} onChange={props.changeHandler} inputClassName={"form-control"} />
      ) : (
        <DateOnlyPicker
          ISOFormattedDate={props.value}
          onChange={props.changeHandler}
          inputClassName={"form-control"}
          preventTimezoneConversion={true}
        />
      )}
    </div>
  );
};

/**
 * Input field with type number in advanced search criteria.
 */
const AdvancedSearchDate: FC<IAdvancedSearchFieldProps & { withTime: boolean }> = (props) => {
  return props.filterOperation.operator === SEARCH_OPERATORS.BETWEEN ? (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: props.verticalLayout ? "column" : "row",
        rowGap: props.verticalLayout ? 5 : null,
        columnGap: props.verticalLayout ? null : 5,
      }}
    >
      <DateInput
        value={props.filterOperation.value as string}
        changeHandler={(value) => props.onChangeState({ value })}
        //autoFocus={props.autoFocus} // disable auto-focus due to SEL8-751
        onBlur={props.onBlur}
        withTime={props.withTime}
      />
      <DateInput
        value={props.filterOperation.value2}
        changeHandler={(value) => props.onChangeState({ value2: value })}
        onBlur={props.onBlur}
        withTime={props.withTime}
      />
    </div>
  ) : (
    <DateInput
      value={props.filterOperation.value as string}
      changeHandler={(value) => props.onChangeState({ value: value })}
      //autoFocus={props.autoFocus} // disable auto-focus due to SEL8-751
      onBlur={props.onBlur}
      withTime={props.withTime}
    />
  );
};
export default AdvancedSearchDate;
